var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3137 4.80234C12.3267 3.06588 14.8357 3.06589 15.8486 4.80234L25.0518 20.5792C26.0726 22.3292 24.8103 24.5269 22.7843 24.5269H4.37798C2.35203 24.5269 1.08974 22.3292 2.11056 20.5792L11.3137 4.80234ZM14.337 5.68411C13.9993 5.10529 13.163 5.1053 12.8254 5.68411L3.62217 21.461C3.2819 22.0443 3.70266 22.7769 4.37798 22.7769H22.7843C23.4597 22.7769 23.8804 22.0443 23.5402 21.461L14.337 5.68411Z",
    fill: "#FF0909"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7061,
    y: 9.65186,
    width: 1.75,
    height: 7.875,
    rx: 0.875,
    fill: "#FF0909"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7051,
    y: 18.375,
    width: 1.75,
    height: 1.75,
    rx: 0.875,
    fill: "#FF0909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a9297ab734df9dbcd68cc7a3d160b902.svg";
export { ForwardRef as ReactComponent };